const PRE_MARKET_COMMAND_PKG = {
    navTitle: "Pre-Market",
    routerName: "Pre-MarketDocs",
    commandsDescription: "Pre-Market, After-Hours, Gainers, etc...",


    commandList: [
        {
            title: "After-Hours Active",
            routerRef: "ahactive",
            commandString: "!ahactive",
            description: "AH Most Active - delayed 15m",
            parameters: ["none"],
            examples: [
                "!ahactive"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "After-Hours Decliners",
            routerRef: "ahdecliners",
            commandString: "!ahdecliners",
            description: "AH decliners - delayed 15m",
            parameters: ["none"],
            examples: [
                "!ahdecliners"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "After-Hours Gainers",
            routerRef: "ahgainers",
            commandString: "!ahgainers",
            description: "AH gainers - delayed 15m",
            parameters: ["none"],
            examples: [
                "!ahgainers"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "Pre-Market Active",
            routerRef: "pmactive",
            commandString: "!pmactive",
            description: "PM Most Active - delayed 15m",
            parameters: ["none"],
            examples: [
                "!pmactive"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "Pre-Market Decliners",
            routerRef: "pmdecliners",
            commandString: "!pmdecliners",
            description: "PM decliners - delayed 15m",
            parameters: ["none"],
            examples: [
                "!pmdecliners"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "Pre-Market Gainers",
            routerRef: "pmgainers",
            commandString: "!pmgainers",
            description: "PM gainers - delayed 15m",
            parameters: ["none"],
            examples: [
                "!pmgainers"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "Pre-Market Volume",
            routerRef: "pm",
            commandString: "!pm <Symbol>",
            description: "Gives Pre Market Volume and High and Low for stock - slightly delayed",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!pm GOOGL",
                "!pm AMD"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "After-Hours Volume",
            routerRef: "ah",
            commandString: "!ah <Symbol>",
            description: "Gives After Hours Volume and High and Low for stock - slightly delayed",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!ah GOOGL",
                "!ah AMD"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "pmprint",
            routerRef: "pmprint",
            commandString: "!pmprint <Symbol>",
            description: "Gives Pre Market Volume and ToS for stock - last 20 prints",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!pmprint GOOGL",
                "!pmprint AMD"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },
        {
            title: "exthrs",
            routerRef: "exthrs",
            commandString: "!exthrs <Symbol>",
            description: "Gives Extended Hours Quote for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!exthrs GOOGL",
                "!exthrs AMD"
            ],
            type: "Pre-Market", 
            shortcuts: ["none"]
        },

    ]


}

// eslint-disable-next-line no-unused-vars

export {PRE_MARKET_COMMAND_PKG};